import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeSanitize from "rehype-sanitize";
import { MESSAGE_FORMAT } from "../../Types/account";
import { decodePromptText, isMarkdownFormat } from "../../utils/socialPromptMessageHelpers";
import "../../Css/Common/SocialPromptMessage.css";

export type SocialPromptMessagePreviewProps = {
  message: string;
  messageFormat: MESSAGE_FORMAT;
  className?: string;
  scroll?: boolean;
};

export const SocialPromptMessagePreview: React.FC<SocialPromptMessagePreviewProps> = ({
  message,
  messageFormat,
  className,
  scroll = false,
}) => {
  const scrollClass = scroll ? " socialPromptMessage_scroll" : "";
  const rootClass = [className, scrollClass].filter(Boolean).join(" ");

  if (!message.trim()) {
    return null;
  }

  if (isMarkdownFormat(messageFormat)) {
    return (
      <div className={`socialPromptMessage_prose${rootClass ? ` ${rootClass}` : ""}`}>
        <ReactMarkdown rehypePlugins={[rehypeSanitize]}>{message}</ReactMarkdown>
      </div>
    );
  }

  return (
    <div className={`socialPromptMessage_plain${rootClass ? ` ${rootClass}` : ""}`}>
      {decodePromptText(message)}
    </div>
  );
};
